import React from 'react';
import * as PropTypes from 'prop-types';
import * as c from '../../constants/filemanager';
import MainMenu from './MainMenu';
import NewConceptMenu from './NewConceptMenu';
import ForkConceptMenu from './ForkConceptMenu';
import OpenConceptMenu from './OpenConceptMenu';
import SaveConceptMenu from './SaveConceptMenu';
import ShareConceptMenu from './ShareConceptMenu';

/**
 * This component acts as a wrapper for all file manager menus.  It shows one of the four possible menus based on
 * the current menu state.  We could have made a container for each of the menus, but this way we only need one
 * container and only have to pass required props to each menu
 */
const FileManager = ({
  menu,
  workingConcept,
  concepts,
  loading,
  isDirty,
  allowCompetition,
  selectMenu,
  closeFileManager,
  newConcept,
  forkConcept,
  toggleSharedConcept,
  openRevision,
  saveRevision,
  loadConcepts,
  currentSpecificationId,
  currentSpecificationName,
  isTeacher,
  studentId,
}) => {
  let content;
  switch (menu) {
    case c.FM_MENU_NEW:
      content = (
        <NewConceptMenu
          isDirty={isDirty}
          close={closeFileManager}
          back={() => selectMenu(c.FM_MENU_MAIN)}
          newConcept={newConcept}
          concepts={concepts}
          loading={loading.command}
        />
      );
      break;
    case c.FM_MENU_OPEN:
      content = (
        <OpenConceptMenu
          close={closeFileManager}
          back={() => selectMenu(c.FM_MENU_MAIN)}
          openRevision={openRevision}
          loadConcepts={loadConcepts}
          concepts={concepts}
          loadingList={loading.designList}
          loadingFile={loading.command}
          currentSpecificationId={currentSpecificationId}
          currentSpecificationName={currentSpecificationName}
          studentId={studentId}
          isTeacher={isTeacher}
        />
      );
      break;
    case c.FM_MENU_FORK:
      content = (
        <ForkConceptMenu
          isDirty={isDirty}
          close={closeFileManager}
          back={() => selectMenu(c.FM_MENU_MAIN)}
          forkConcept={forkConcept}
          concepts={concepts}
          loading={loading.command}
          loadConcepts={loadConcepts}
          loadingList={loading.designList}
        />
      );
      break;
    case c.FM_MENU_SAVE:
      content = (
        <SaveConceptMenu
          close={closeFileManager}
          back={() => selectMenu(c.FM_MENU_MAIN)}
          saveRevision={saveRevision}
          conceptName={workingConcept}
          concepts={concepts}
          allowCompetition={allowCompetition}
          saving={loading.command}
        />
      );
      break;
    case c.FM_MENU_SHARE:
      content = (
        <ShareConceptMenu
          loadConcepts={loadConcepts}
          toggleSharedConcept={toggleSharedConcept}
          back={() => selectMenu(c.FM_MENU_MAIN)}
          close={closeFileManager}
          loading={loading.command}
          loadingList={loading.designList}
          concepts={concepts}
        />
      );
      break;
    default:
      content = (
        <MainMenu
          selectMenu={selectMenu}
          close={closeFileManager}
          workingConcept={workingConcept}
          isTeacher={isTeacher}
        />
      );
      break;
  }

  return (
    <div className="fm-simple" id="file-manager">
      {content}
    </div>
  );
};

FileManager.propTypes = {
  menu: PropTypes.string,
  currentConcept: PropTypes.string,
  allowCompetition: PropTypes.bool,
  selectMenu: PropTypes.func,
  closeFileManager: PropTypes.func,
  openRevision: PropTypes.func,
  saveRevision: PropTypes.func,
  loadConcepts: PropTypes.func,
};

export default FileManager;
